import type Phaser from 'phaser';
import type { Platform, PlatformAudio, PlatformHaptics, PlatformStorage } from './interfaces';

class WebStorage implements PlatformStorage {
  get(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  }
  set(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch {
      /* private mode or quota; settings are a convenience, not critical */
    }
  }
  remove(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch {
      /* ignore */
    }
  }
}

class PhaserWebAudio implements PlatformAudio {
  constructor(private readonly sound: Phaser.Sound.BaseSoundManager) {}
  unlock(): void {
    if (!this.sound.locked) return;
    // Every concrete manager (WebAudio, HTML5, NoAudio) exposes unlock() publicly;
    // only the abstract base class marks it protected, so narrow through the cast.
    (this.sound as unknown as { unlock(): void }).unlock();
  }
  get isUnlocked(): boolean {
    return !this.sound.locked;
  }
}

class NoopHaptics implements PlatformHaptics {
  tap(): void {
    /* no haptics on the web; Capacitor provides them in Phase 2 */
  }
}

export function createWebPlatform(sound: Phaser.Sound.BaseSoundManager): Platform {
  return {
    storage: new WebStorage(),
    audio: new PhaserWebAudio(sound),
    haptics: new NoopHaptics(),
  };
}
